export enum FORM_LAYOUT {
  GRID_1_COL = 'grid grid-cols-1 gap-4',
  GRID_2_COLS = 'grid grid-cols-1 md:grid-cols-2 gap-4',
  GRID_3_COLS = 'grid grid-cols-1 md:grid-cols-3 gap-4',
  GRID_4_COLS = 'grid grid-cols-1 md:grid-cols-4 gap-4',
  GRID_5_COLS = 'grid grid-cols-5 gap-4',

  USE_1_COL = 'col-span-1',
  USE_2_COLS = 'col-span-2',
  USE_3_COLS = 'col-span-3',
  USE_4_COLS = 'col-span-4',
  USE_ALL_COLS = 'col-span-full',

  START_NEXT_ROW = 'col-start-1',
  START_COL_4 = 'col-start-4',
  START_COL_4_MD = 'md:col-start-4',
  START_COL_4_LG = 'lg:col-start-4',
  // response classes -> we need them, because otherwise Tailwind wont export necessary css for those classes (so do not concat!)
  USE_1_COL_MD = 'md:col-span-1',
  USE_2_COL_MD = 'md:col-span-2',
  USE_1_COL_LG = 'lg:col-span-1',
  USE_ALL_COLS_LG = 'lg:col-span-full',

  USE_1_COL_XL = 'xl:col-span-1',
  USE_2_COL_XL = 'xl:col-span-2',
  USE_3_COL_XL = 'xl:col-span-3',
  USE_4_COL_XL = 'xl:col-span-4',

  START_AUTO_XL = 'xl:col-start-auto',

  START_NEXT_ROW_MD = 'md:col-start-1',

  START_NEXT_ROW_LG = 'lg:col-start-1',
  START_NEXT_ROW_XL = 'xl:col-start-1',
}
